import React, { useState } from 'react';
import { DollarSignIcon, DownloadIcon, ChevronDownIcon, DatabaseIcon, UsersIcon, ArrowUpIcon, ActivityIcon, GaugeIcon, TrendingUpIcon, AlertTriangleIcon, BarChart4Icon, LineChartIcon, PieChartIcon, BellIcon, LightbulbIcon, ZapIcon, PercentIcon, CalendarIcon, FilterIcon } from 'lucide-react';
export function CostIntelligence() {
  const [costTimeRange, setCostTimeRange] = useState('30d');
  return <div className="space-y-6 text-white" data-id="element-951">
      <div className="flex items-center justify-between mb-4" data-id="element-952">
        <h2 className="text-2xl font-bold text-white flex items-center" data-id="element-953">
          <DollarSignIcon size={24} className="mr-2 text-green-400" data-id="element-954" />
          Cost Intelligence
        </h2>
        <button className="px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors text-sm flex items-center" data-id="element-955">
          <DownloadIcon size={16} className="mr-2" data-id="element-956" />
          Export Report
        </button>
      </div>
      {/* Clear SaaS Model Cost heading */}
      <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222] mb-4" data-id="element-957">
        <h3 className="text-lg font-medium text-white flex items-center" data-id="element-958">
          <DollarSignIcon size={20} className="mr-2 text-blue-400" data-id="element-959" />
          SaaS Model Cost
        </h3>
        <p className="text-sm text-gray-400 mt-2" data-id="element-960">
          Detailed cost analysis and insights for all your SaaS AI model usage.
        </p>
      </div>
      {/* Filter Controls */}
      <div className="flex flex-wrap gap-3" data-id="element-961">
        {/* Time Range Selector */}
        <div className="bg-[#121212] rounded-lg border border-[#333] overflow-hidden flex shadow-inner" data-id="element-962">
          <button className={`px-3 py-1.5 text-sm ${costTimeRange === '24h' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-[#1a1a1a]'}`} onClick={() => setCostTimeRange('24h')} data-id="element-963">
            24h
          </button>
          <button className={`px-3 py-1.5 text-sm ${costTimeRange === '7d' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-[#1a1a1a]'}`} onClick={() => setCostTimeRange('7d')} data-id="element-964">
            7d
          </button>
          <button className={`px-3 py-1.5 text-sm ${costTimeRange === '30d' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-[#1a1a1a]'}`} onClick={() => setCostTimeRange('30d')} data-id="element-965">
            30d
          </button>
          <button className={`px-3 py-1.5 text-sm ${costTimeRange === '90d' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-[#1a1a1a]'}`} onClick={() => setCostTimeRange('90d')} data-id="element-966">
            90d
          </button>
        </div>
        {/* Model Filter */}
        <div className="relative" data-id="element-967">
          <button className="flex items-center gap-2 bg-[#121212] text-gray-100 px-3 py-1.5 rounded-lg border border-[#333] hover:bg-[#1a1a1a] transition-colors text-sm" data-id="element-968">
            <DatabaseIcon size={16} data-id="element-969" />
            <span data-id="element-970">All Models</span>
            <ChevronDownIcon size={16} data-id="element-971" />
          </button>
        </div>
        {/* Team Filter */}
        <div className="relative" data-id="element-972">
          <button className="flex items-center gap-2 bg-[#121212] text-gray-100 px-3 py-1.5 rounded-lg border border-[#333] hover:bg-[#1a1a1a] transition-colors text-sm" data-id="element-973">
            <UsersIcon size={16} data-id="element-974" />
            <span data-id="element-975">All Teams</span>
            <ChevronDownIcon size={16} data-id="element-976" />
          </button>
        </div>
        {/* Export Button */}
        <button className="flex items-center gap-2 bg-[#121212] text-gray-100 px-3 py-1.5 rounded-lg border border-[#333] hover:bg-[#1a1a1a] transition-colors text-sm ml-auto" data-id="element-977">
          <DownloadIcon size={16} data-id="element-978" />
          <span data-id="element-979">Export</span>
        </button>
      </div>
      {/* Cost Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-980">
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222] transition-all duration-300 hover:border-[#333] hover:shadow-lg" data-id="element-981">
          <h3 className="text-sm font-medium text-gray-400 mb-2 flex items-center" data-id="element-982">
            <DollarSignIcon size={16} className="mr-2 text-blue-400" data-id="element-983" />
            Total SaaS Cost ({costTimeRange})
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-984">$4,827.47</p>
          <div className="mt-2 text-xs text-green-400 flex items-center" data-id="element-985">
            <ArrowUpIcon size={12} className="mr-1" data-id="element-986" />
            12.4% from previous period
          </div>
        </div>
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222] transition-all duration-300 hover:border-[#333] hover:shadow-lg" data-id="element-987">
          <h3 className="text-sm font-medium text-gray-400 mb-2 flex items-center" data-id="element-988">
            <ActivityIcon size={16} className="mr-2 text-purple-400" data-id="element-989" />
            Total Tokens
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-990">1.32B</p>
          <div className="flex justify-between mt-2 text-xs text-gray-400" data-id="element-991">
            <span data-id="element-992">Input: 326M</span>
            <span data-id="element-993">Output: 994M</span>
          </div>
        </div>
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222] transition-all duration-300 hover:border-[#333] hover:shadow-lg" data-id="element-994">
          <h3 className="text-sm font-medium text-gray-400 mb-2 flex items-center" data-id="element-995">
            <GaugeIcon size={16} className="mr-2 text-green-400" data-id="element-996" />
            Avg. Cost / 1K Tokens
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-997">$0.0038</p>
          <div className="mt-2 text-xs text-red-400 flex items-center" data-id="element-998">
            <ArrowUpIcon size={12} className="mr-1" data-id="element-999" />
            3.2% from previous period
          </div>
        </div>
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222] transition-all duration-300 hover:border-[#333] hover:shadow-lg" data-id="element-1000">
          <h3 className="text-sm font-medium text-gray-400 mb-2 flex items-center" data-id="element-1001">
            <TrendingUpIcon size={16} className="mr-2 text-yellow-400" data-id="element-1002" />
            Projected Monthly
          </h3>
          <p className="text-2xl font-semibold text-white" data-id="element-1003">$19,310</p>
          <div className="mt-2 text-xs text-yellow-400 flex items-center" data-id="element-1004">
            <AlertTriangleIcon size={12} className="mr-1" data-id="element-1005" />
            80.5% of budget
          </div>
        </div>
      </div>
      {/* Cost Breakdown Section */}
      <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222]" data-id="element-1006">
        <h3 className="text-base font-medium text-white mb-4 flex items-center" data-id="element-1007">
          <BarChart4Icon size={16} className="mr-2 text-blue-400" data-id="element-1008" />
          SaaS Cost Breakdown
        </h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1009">
          {/* Cost by Model */}
          <div data-id="element-1010">
            <h4 className="text-sm font-medium text-gray-300 mb-3" data-id="element-1011">
              Cost by Model
            </h4>
            <div className="space-y-3" data-id="element-1012">
              <div className="flex items-center justify-between" data-id="element-1013">
                <div className="flex items-center" data-id="element-1014">
                  <div className="h-3 w-3 rounded-full bg-blue-500 mr-2" data-id="element-1015"></div>
                  <span className="text-sm text-gray-300" data-id="element-1016">GPT-4o</span>
                </div>
                <div className="flex items-center" data-id="element-1017">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1018">
                    $2,845.32
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1019">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '59.0%'
                  }} data-id="element-1020"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1021">59.0%</span>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1022">
                <div className="flex items-center" data-id="element-1023">
                  <div className="h-3 w-3 rounded-full bg-purple-500 mr-2" data-id="element-1024"></div>
                  <span className="text-sm text-gray-300" data-id="element-1025">Claude-3.5</span>
                </div>
                <div className="flex items-center" data-id="element-1026">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1027">
                    $1,582.15
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1028">
                    <div className="bg-purple-500 h-2 rounded-full" style={{
                    width: '32.8%'
                  }} data-id="element-1029"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1030">32.8%</span>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1031">
                <div className="flex items-center" data-id="element-1032">
                  <div className="h-3 w-3 rounded-full bg-yellow-500 mr-2" data-id="element-1033"></div>
                  <span className="text-sm text-gray-300" data-id="element-1034">
                    Other SaaS Models
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1035">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1036">
                    $400.00
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1037">
                    <div className="bg-yellow-500 h-2 rounded-full" style={{
                    width: '8.2%'
                  }} data-id="element-1038"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1039">8.2%</span>
                </div>
              </div>
            </div>
          </div>
          {/* Cost by Department */}
          <div data-id="element-1040">
            <h4 className="text-sm font-medium text-gray-300 mb-3" data-id="element-1041">
              Cost by Department
            </h4>
            <div className="space-y-3" data-id="element-1042">
              <div className="flex items-center justify-between" data-id="element-1043">
                <div className="flex items-center" data-id="element-1044">
                  <div className="h-3 w-3 rounded-full bg-blue-500 mr-2" data-id="element-1045"></div>
                  <span className="text-sm text-gray-300" data-id="element-1046">Engineering</span>
                </div>
                <div className="flex items-center" data-id="element-1047">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1048">
                    $1,738.89
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1049">
                    <div className="bg-blue-500 h-2 rounded-full" style={{
                    width: '36.0%'
                  }} data-id="element-1050"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1051">36.0%</span>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1052">
                <div className="flex items-center" data-id="element-1053">
                  <div className="h-3 w-3 rounded-full bg-purple-500 mr-2" data-id="element-1054"></div>
                  <span className="text-sm text-gray-300" data-id="element-1055">Research</span>
                </div>
                <div className="flex items-center" data-id="element-1056">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1057">
                    $1,448.24
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1058">
                    <div className="bg-purple-500 h-2 rounded-full" style={{
                    width: '30.0%'
                  }} data-id="element-1059"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1060">30.0%</span>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1061">
                <div className="flex items-center" data-id="element-1062">
                  <div className="h-3 w-3 rounded-full bg-green-500 mr-2" data-id="element-1063"></div>
                  <span className="text-sm text-gray-300" data-id="element-1064">Product</span>
                </div>
                <div className="flex items-center" data-id="element-1065">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1066">
                    $965.49
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1067">
                    <div className="bg-green-500 h-2 rounded-full" style={{
                    width: '20.0%'
                  }} data-id="element-1068"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1069">20.0%</span>
                </div>
              </div>
              <div className="flex items-center justify-between" data-id="element-1070">
                <div className="flex items-center" data-id="element-1071">
                  <div className="h-3 w-3 rounded-full bg-yellow-500 mr-2" data-id="element-1072"></div>
                  <span className="text-sm text-gray-300" data-id="element-1073">
                    Customer Support
                  </span>
                </div>
                <div className="flex items-center" data-id="element-1074">
                  <span className="text-sm font-medium text-white mr-4" data-id="element-1075">
                    $675.85
                  </span>
                  <div className="w-24 bg-[#222] rounded-full h-2" data-id="element-1076">
                    <div className="bg-yellow-500 h-2 rounded-full" style={{
                    width: '14.0%'
                  }} data-id="element-1077"></div>
                  </div>
                  <span className="text-xs text-gray-300 ml-2" data-id="element-1078">14.0%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Cost Trends and Usage Analytics */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-1079">
        {/* Historical Trend */}
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222]" data-id="element-1080">
          <h3 className="text-base font-medium text-white mb-4 flex items-center" data-id="element-1081">
            <LineChartIcon size={16} className="mr-2 text-blue-400" data-id="element-1082" />
            SaaS Cost Trend
          </h3>
          <div className="h-60 relative" data-id="element-1083">
            {/* This would be a real chart component in a complete implementation */}
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-1084">
              <div className="w-full h-full bg-[#121212] rounded-lg border border-[#333] p-3" data-id="element-1085">
                <div className="h-full flex items-end justify-between px-2" data-id="element-1086">
                  <div className="h-[30%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1087"></div>
                  <div className="h-[45%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1088"></div>
                  <div className="h-[40%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1089"></div>
                  <div className="h-[60%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1090"></div>
                  <div className="h-[55%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1091"></div>
                  <div className="h-[75%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1092"></div>
                  <div className="h-[85%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1093"></div>
                  <div className="h-[65%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1094"></div>
                  <div className="h-[70%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1095"></div>
                  <div className="h-[90%] w-6 bg-blue-500 rounded-t-sm" data-id="element-1096"></div>
                </div>
                <div className="mt-2 flex justify-between text-xs text-gray-400" data-id="element-1097">
                  <span data-id="element-1098">Week 1</span>
                  <span data-id="element-1099">Week 2</span>
                  <span data-id="element-1100">Week 3</span>
                  <span data-id="element-1101">Week 4</span>
                  <span data-id="element-1102">Week 5</span>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-4 grid grid-cols-3 gap-2 text-center" data-id="element-1103">
            <div className="bg-[#121212] p-2 rounded-lg border border-[#333]" data-id="element-1104">
              <div className="text-xs text-gray-400" data-id="element-1105">Daily Avg</div>
              <div className="text-sm font-medium text-white" data-id="element-1106">$689.64</div>
            </div>
            <div className="bg-[#121212] p-2 rounded-lg border border-[#333]" data-id="element-1107">
              <div className="text-xs text-gray-400" data-id="element-1108">Weekly Avg</div>
              <div className="text-sm font-medium text-white" data-id="element-1109">$4,827.47</div>
            </div>
            <div className="bg-[#121212] p-2 rounded-lg border border-[#333]" data-id="element-1110">
              <div className="text-xs text-gray-400" data-id="element-1111">Monthly Proj</div>
              <div className="text-sm font-medium text-white" data-id="element-1112">$19,310.00</div>
            </div>
          </div>
        </div>
        {/* SaaS Model Performance */}
        <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222]" data-id="element-1113">
          <h3 className="text-base font-medium text-white mb-4 flex items-center" data-id="element-1114">
            <PieChartIcon size={16} className="mr-2 text-purple-400" data-id="element-1115" />
            SaaS Model Performance
          </h3>
          <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-1116">
            <div className="bg-[#121212] p-3 rounded-lg border border-[#333] text-center" data-id="element-1117">
              <div className="text-sm font-medium text-gray-400 mb-1" data-id="element-1118">
                GPT-4o
              </div>
              <div className="text-xl font-semibold text-white" data-id="element-1119">$2,845.32</div>
              <div className="text-xs text-gray-400 mt-1" data-id="element-1120">59.0% of total</div>
              <div className="mt-2 h-2 bg-[#222] rounded-full" data-id="element-1121">
                <div className="h-2 bg-blue-500 rounded-full" style={{
                width: '59.0%'
              }} data-id="element-1122"></div>
              </div>
            </div>
            <div className="bg-[#121212] p-3 rounded-lg border border-[#333] text-center" data-id="element-1123">
              <div className="text-sm font-medium text-gray-400 mb-1" data-id="element-1124">
                Claude-3.5
              </div>
              <div className="text-xl font-semibold text-white" data-id="element-1125">$1,582.15</div>
              <div className="text-xs text-gray-400 mt-1" data-id="element-1126">32.8% of total</div>
              <div className="mt-2 h-2 bg-[#222] rounded-full" data-id="element-1127">
                <div className="h-2 bg-purple-500 rounded-full" style={{
                width: '32.8%'
              }} data-id="element-1128"></div>
              </div>
            </div>
          </div>
          <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1129">
            <h4 className="text-sm font-medium text-white mb-2" data-id="element-1130">
              SaaS Model Pricing Analysis
            </h4>
            <div className="space-y-2" data-id="element-1131">
              <div className="flex justify-between text-sm" data-id="element-1132">
                <span className="text-gray-400" data-id="element-1133">GPT-4o cost / 1M tokens:</span>
                <span className="text-white" data-id="element-1134">$4.28</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1135">
                <span className="text-gray-400" data-id="element-1136">
                  Claude-3.5 cost / 1M tokens:
                </span>
                <span className="text-white" data-id="element-1137">$3.80</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-1138">
                <span className="text-gray-400" data-id="element-1139">Token usage efficiency:</span>
                <span className="text-yellow-400" data-id="element-1140">Medium (62%)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Forecast and Optimization */}
      <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222]" data-id="element-1141">
        <h3 className="text-base font-medium text-white mb-4 flex items-center" data-id="element-1142">
          <TrendingUpIcon size={16} className="mr-2 text-yellow-400" data-id="element-1143" />
          SaaS Cost Forecast & Optimization
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1144">
          {/* Forecast */}
          <div data-id="element-1145">
            <h4 className="text-sm font-medium text-gray-300 mb-3" data-id="element-1146">
              Cost Projections
            </h4>
            <div className="space-y-4" data-id="element-1147">
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1148">
                <div className="flex justify-between mb-1" data-id="element-1149">
                  <span className="text-sm text-gray-300" data-id="element-1150">
                    30-day Projection
                  </span>
                  <span className="text-sm font-medium text-white" data-id="element-1151">
                    $19,310.00
                  </span>
                </div>
                <div className="h-2 bg-[#222] rounded-full" data-id="element-1152">
                  <div className="h-2 bg-yellow-500 rounded-full" style={{
                  width: '80.5%'
                }} data-id="element-1153"></div>
                </div>
                <div className="flex justify-between mt-1 text-xs" data-id="element-1154">
                  <span className="text-gray-400" data-id="element-1155">Current</span>
                  <span className="text-yellow-400" data-id="element-1156">
                    80.5% of $24,000 budget
                  </span>
                </div>
              </div>
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1157">
                <div className="flex justify-between mb-1" data-id="element-1158">
                  <span className="text-sm text-gray-300" data-id="element-1159">
                    90-day Projection
                  </span>
                  <span className="text-sm font-medium text-white" data-id="element-1160">
                    $61,792.00
                  </span>
                </div>
                <div className="h-2 bg-[#222] rounded-full" data-id="element-1161">
                  <div className="h-2 bg-red-500 rounded-full" style={{
                  width: '85.8%'
                }} data-id="element-1162"></div>
                </div>
                <div className="flex justify-between mt-1 text-xs" data-id="element-1163">
                  <span className="text-gray-400" data-id="element-1164">Current</span>
                  <span className="text-red-400" data-id="element-1165">85.8% of $72,000 budget</span>
                </div>
              </div>
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1166">
                <div className="flex items-center mb-2" data-id="element-1167">
                  <BellIcon size={14} className="text-yellow-400 mr-2" data-id="element-1168" />
                  <span className="text-sm font-medium text-yellow-400" data-id="element-1169">
                    Budget Threshold Alerts
                  </span>
                </div>
                <div className="space-y-2" data-id="element-1170">
                  <div className="flex items-start" data-id="element-1171">
                    <AlertTriangleIcon size={14} className="text-yellow-400 mt-0.5 mr-2" data-id="element-1172" />
                    <div data-id="element-1173">
                      <p className="text-xs text-gray-300" data-id="element-1174">
                        Engineering team will exceed monthly budget by ~$2,450
                        at current usage rate
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1175">
                    <AlertTriangleIcon size={14} className="text-yellow-400 mt-0.5 mr-2" data-id="element-1176" />
                    <div data-id="element-1177">
                      <p className="text-xs text-gray-300" data-id="element-1178">
                        GPT-4o usage trending 18% higher than previous month
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Optimization */}
          <div data-id="element-1179">
            <h4 className="text-sm font-medium text-gray-300 mb-3" data-id="element-1180">
              SaaS Cost Optimization
            </h4>
            <div className="space-y-4" data-id="element-1181">
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1182">
                <h5 className="text-sm font-medium text-white mb-2 flex items-center" data-id="element-1183">
                  <LightbulbIcon size={14} className="text-green-400 mr-2" data-id="element-1184" />
                  SaaS Model Efficiency Scores
                </h5>
                <div className="space-y-2" data-id="element-1185">
                  <div className="flex justify-between text-sm" data-id="element-1186">
                    <div className="flex items-center" data-id="element-1187">
                      <div className="h-2 w-2 rounded-full bg-yellow-500 mr-2" data-id="element-1188"></div>
                      <span className="text-gray-300" data-id="element-1189">Claude-3.5</span>
                    </div>
                    <span className="text-white" data-id="element-1190">78/100</span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-1191">
                    <div className="flex items-center" data-id="element-1192">
                      <div className="h-2 w-2 rounded-full bg-red-500 mr-2" data-id="element-1193"></div>
                      <span className="text-gray-300" data-id="element-1194">GPT-4o</span>
                    </div>
                    <span className="text-white" data-id="element-1195">65/100</span>
                  </div>
                </div>
              </div>
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1196">
                <h5 className="text-sm font-medium text-white mb-2 flex items-center" data-id="element-1197">
                  <ZapIcon size={14} className="text-blue-400 mr-2" data-id="element-1198" />
                  SaaS Cost-Saving Recommendations
                </h5>
                <div className="space-y-2" data-id="element-1199">
                  <div className="flex items-start" data-id="element-1200">
                    <div className="flex-shrink-0 h-5 w-5 bg-blue-900/30 rounded-full flex items-center justify-center mr-2 mt-0.5" data-id="element-1201">
                      <span className="text-xs font-medium text-blue-400" data-id="element-1202">
                        1
                      </span>
                    </div>
                    <div data-id="element-1203">
                      <p className="text-xs text-gray-300" data-id="element-1204">
                        Optimize prompt length to reduce token usage by up to
                        22%
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1205">
                    <div className="flex-shrink-0 h-5 w-5 bg-blue-900/30 rounded-full flex items-center justify-center mr-2 mt-0.5" data-id="element-1206">
                      <span className="text-xs font-medium text-blue-400" data-id="element-1207">
                        2
                      </span>
                    </div>
                    <div data-id="element-1208">
                      <p className="text-xs text-gray-300" data-id="element-1209">
                        Implement token caching for repetitive queries to reduce
                        token usage by ~15%
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-1210">
                    <div className="flex-shrink-0 h-5 w-5 bg-blue-900/30 rounded-full flex items-center justify-center mr-2 mt-0.5" data-id="element-1211">
                      <span className="text-xs font-medium text-blue-400" data-id="element-1212">
                        3
                      </span>
                    </div>
                    <div data-id="element-1213">
                      <p className="text-xs text-gray-300" data-id="element-1214">
                        Use Claude-3.5 for appropriate tasks to reduce costs by
                        approximately 12%
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-[#121212] p-3 rounded-lg border border-[#333]" data-id="element-1215">
                <h5 className="text-sm font-medium text-white mb-2 flex items-center" data-id="element-1216">
                  <PercentIcon size={14} className="text-purple-400 mr-2" data-id="element-1217" />
                  External API Charges
                </h5>
                <div className="space-y-2" data-id="element-1218">
                  <div className="flex justify-between text-sm" data-id="element-1219">
                    <span className="text-gray-300" data-id="element-1220">OpenAI API</span>
                    <span className="text-white" data-id="element-1221">$3,245.32</span>
                  </div>
                  <div className="flex justify-between text-sm" data-id="element-1222">
                    <span className="text-gray-300" data-id="element-1223">Anthropic API</span>
                    <span className="text-white" data-id="element-1224">$1,582.15</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Top Users Table */}
      <div className="bg-[#0F0F0F] rounded-xl p-4 border border-[#222]" data-id="element-1225">
        <div className="flex items-center justify-between mb-4" data-id="element-1226">
          <h3 className="text-base font-medium text-white flex items-center" data-id="element-1227">
            <UsersIcon size={16} className="mr-2 text-blue-400" data-id="element-1228" />
            Top SaaS Model Users by Cost
          </h3>
          <button className="px-2 py-1 text-xs text-gray-300 bg-[#121212] rounded border border-[#333] hover:bg-[#1a1a1a]" data-id="element-1229">
            View All
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-1230">
          <table className="min-w-full divide-y divide-[#222]" data-id="element-1231">
            <thead data-id="element-1232">
              <tr className="bg-[#121212]" data-id="element-1233">
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1234">
                  User
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1235">
                  Department
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1236">
                  Cost
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1237">
                  Tokens
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-400 uppercase tracking-wider" data-id="element-1238">
                  Primary Model
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#222] bg-[#0F0F0F]" data-id="element-1239">
              <tr className="hover:bg-[#121212] transition-colors" data-id="element-1240">
                <td className="px-4 py-3 text-sm text-white" data-id="element-1241">Alex Johnson</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1242">Engineering</td>
                <td className="px-4 py-3 text-sm text-white" data-id="element-1243">$842.56</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1244">245.3M</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1245">GPT-4o</td>
              </tr>
              <tr className="hover:bg-[#121212] transition-colors" data-id="element-1246">
                <td className="px-4 py-3 text-sm text-white" data-id="element-1247">Maria Garcia</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1248">Research</td>
                <td className="px-4 py-3 text-sm text-white" data-id="element-1249">$756.32</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1250">198.7M</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1251">Claude-3.5</td>
              </tr>
              <tr className="hover:bg-[#121212] transition-colors" data-id="element-1252">
                <td className="px-4 py-3 text-sm text-white" data-id="element-1253">David Kim</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1254">Product</td>
                <td className="px-4 py-3 text-sm text-white" data-id="element-1255">$682.18</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1256">175.4M</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1257">GPT-4o</td>
              </tr>
              <tr className="hover:bg-[#121212] transition-colors" data-id="element-1258">
                <td className="px-4 py-3 text-sm text-white" data-id="element-1259">Sarah Chen</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1260">Engineering</td>
                <td className="px-4 py-3 text-sm text-white" data-id="element-1261">$524.95</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1262">142.8M</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1263">GPT-4o</td>
              </tr>
              <tr className="hover:bg-[#121212] transition-colors" data-id="element-1264">
                <td className="px-4 py-3 text-sm text-white" data-id="element-1265">James Wilson</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1266">
                  Customer Support
                </td>
                <td className="px-4 py-3 text-sm text-white" data-id="element-1267">$468.72</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1268">124.3M</td>
                <td className="px-4 py-3 text-sm text-gray-300" data-id="element-1269">Claude-3.5</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}